import { format } from '@sravni/utils/lib/money';

import type { Condition } from '../../../hooks/useProductData';

export const getBiznesVedConditions = (item): Condition[] => {
  // Стоимость обслуживания
  const conditions = [];

  const { monthlyMaintenance, monthlyMaintenanceFix, currencyFixWithTerm } = item;

  let priceValue = 'Индивидуально';
  const formattedMonthlyMaintenanceFix = format(monthlyMaintenanceFix);

  if (monthlyMaintenance < 0.001 && monthlyMaintenanceFix < 0.001) {
    priceValue = 'Бесплатно';
  } else if (monthlyMaintenance >= 0.001 && monthlyMaintenanceFix < 0.001) {
    priceValue = `от ${monthlyMaintenance}% в месяц`;
  } else if (currencyFixWithTerm === 'symbolTermRUB' && monthlyMaintenanceFix >= 0.001) {
    priceValue = `от ${formattedMonthlyMaintenanceFix} ₽/мес.`;
  } else if (currencyFixWithTerm === 'symbolTermUSD' && monthlyMaintenanceFix >= 0.001) {
    priceValue = `от ${formattedMonthlyMaintenanceFix} $/мес.`;
  } else if (currencyFixWithTerm === 'symbolTermEUR' && monthlyMaintenanceFix >= 0.001) {
    priceValue = `от ${formattedMonthlyMaintenanceFix} €/мес.`;
  } else if (monthlyMaintenanceFix < 0.01) {
    priceValue = 'Бесплатно';
  }

  conditions.push({ value: priceValue, description: 'Стоимость обслуживания' });

  return conditions;
};
